import { useApi } from "../../../swr/useApi";
import { documentsService } from "../../api_client";
import type { UsersDocumentsResponseDto } from "../../../api";
import { DocumentsQueryDtoStatusEnum } from "../../../api";

function useStatusCount(status: DocumentsQueryDtoStatusEnum) {
  return useApi<UsersDocumentsResponseDto>(
    `document-review-stats-${status}`,
    () => documentsService.getDocumentsGroupedByUser({ page: 1, pageSize: 1, status }),
  );
}

export function useDocumentReviewStats() {
  const approved = useStatusCount(DocumentsQueryDtoStatusEnum.Approved);
  const pending = useStatusCount(DocumentsQueryDtoStatusEnum.Pending);
  const rejected = useStatusCount(DocumentsQueryDtoStatusEnum.Rejected);

  return {
    approved: approved.data?.meta?.totalCount,
    pending: pending.data?.meta?.totalCount,
    rejected: rejected.data?.meta?.totalCount,
  };
}
